import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!\n  Copyright (c) HashiCorp, Inc.\n}}\n\n{{yield}}")